//internal-deps
import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { STORAGE_TYPES } from "@swiggy-private/native-bridge";

/* Helper functions to get and set values in App storage via native bridge */
export const getFrequencyCapValue = async (storageKey: string) => {
    try {
        const response = await getBridgeSdk().storage({
            type: STORAGE_TYPES.GET,
            data: {
                [storageKey]: "",
            },
        });

        return {
            [storageKey]: response?.data?.[storageKey] ?? "0",
        };
    } catch (e) {
        return Promise.resolve(null);
    }
};

export const updateFrequencyCapValue = async (prevData: { [key: string]: string }, storageKey: string) => {
    try {
        const data: { [key: string]: string } = {};

        const prevCount = prevData[storageKey] ?? "0";
        const updatedCount = Number(prevCount) + 1;
        data[storageKey] = String(updatedCount);

        await getBridgeSdk().storage({
            type: STORAGE_TYPES.SAVE,
            data,
        });
    } catch (e) {
        // noop
    }
};
